import { createModel, RematchDispatch } from '@rematch/core';
import { message } from 'antd';
import produce from 'immer';
import { DEFAULT_PAGINATION } from '../../../commons/constants/constants';
import { PageRequest } from '../../../types/CommonTypes';
import { storeName as entityStore } from '../../entities/admin/sceneAdmin.entity';
import { RootModel } from '../../models';

export const storeName = 'sceneAdmin';

const initialState = {
  ids: [],
  pagination: DEFAULT_PAGINATION,
  loading: false,
  criteria: {},
};

export const sceneAdmin: any = createModel<RootModel>()({
  name: storeName,
  state: initialState,
  reducers: {
    setLoading: produce((state, payload) => {
      state.loading = payload;
    }),
    setIds: produce((state, payload) => {
      state.ids = payload;
    }),
    setPagination: produce((state, payload) => {
      state.pagination = payload;
    }),
    setCriteria: produce((state, payload) => {
      state.criteria = payload;
    }),
  },
  effects: (dispatch: RematchDispatch<typeof sceneAdmin>) => ({
    async reloadList(_, state) {
      const { criteria, pagination } = state[storeName];
      await this.filterAsync({ ...pagination, ...criteria });
    },
    async resetFilter(payload, state) {
      const { pagination } = state[storeName];
      await this.filterAsync({ ...pagination, page: 0 });
    },
    async pagingAsync(payload: PageRequest, state) {
      const { criteria = {}, pagination = {} } = state[storeName];
      await this.filterAsync({ ...pagination, ...criteria, ...payload });
    },
    async filterAsync(params = {}) {
      this.setLoading(true);
      try {
        const data = await dispatch[entityStore].load(params);
        if (data && data.content) {
          this.setIds(data.content.map((scene) => scene.id));
          this.setPagination((({ content, ...otherProps }) => otherProps)(data));
          this.setCriteria(params);
        }
      } catch (e) {
        console.error(e);
        message.error('Failed to filter scenes');
      } finally {
        this.setLoading(false);
      }
    },
  }),
});

export default sceneAdmin;
